// @ts-ignore
import ShopifyBuy from 'shopify-buy';
import { Client } from 'shopify-buy';

const shopifyClient: Client = ShopifyBuy.buildClient({
  // @ts-ignore
  domain: process.env['REACT_APP_SHOPIFY_CLIENT_DOMAIN'],
  // @ts-ignore
  storefrontAccessToken: process.env['REACT_APP_SHOPIFY_CLIENT_STOREFRONT_ACCESS_TOKEN'],
});

export default shopifyClient;
